export default __webpack_public_path__ + "static/nav_claw-5e2321bcac4f1e395a604ed9ab922c07.png";